@if (data(); as data) {

  <form (ngSubmit)="onSubmit()" [formGroup]="form">

    <evland-modal-container (onClose)="onClose()" [title]="data.title" [withFooter]="true">

      <evland-form-field label="Ваше ім'я" i18n-label>
        <input evlandInput formControlName="name" id="name" />
      </evland-form-field>

      <evland-form-field label="Номер телефону" i18n-label>
        <input [imask]="{ mask: '+{38\\0} (00) 000-00-00' }" [unmask]="true" evlandInput formControlName="phone_number"
               placeholder="+380 (XX) XXX-XX-XX" />
      </evland-form-field>

      <evland-form-field label="Вподобаний офіс" i18n-label>
        <select evlandInput formControlName="preferred_office">
          <option disabled value="" i18n>Оберіть офіс</option>
          @for (option of officeOptions; track option.value) {
            <option [value]="option.value">{{option.label}}</option>
          }
        </select>
      </evland-form-field>

      <ng-container modal-footer>
        <evland-submit-button [disabled]="form.invalid" [isLoading]="isSubmitting()" class="submit-button">{{ data.action_label }}
        </evland-submit-button>
      </ng-container>

    </evland-modal-container>

  </form>

}
